<template>
  <div class="navigation-container" :class="colorPalette">
    <div class="navigation-header">
      <div class="logo-stack" @click="redirectToHomeOrLogin()">
        <brand-marker-icon />
        <div class="wordmark">
          <wordmark />
        </div>
        {{ $t('product.accounts.title_short') }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { watch } from 'vue';
import { Authenticator, useAuthentication, usePalette, BrandMarkerIcon, Wordmark} from 'ihunter-pathfinder-components';
import { useRouteManager } from '../composables/useRouteManager';

const { colorPalette } = usePalette({ palette: 'darkmap' });
const { user, signOut } = useAuthentication();
const { redirectToHomeOrLogin } = useRouteManager();

watch(user, async (user) => {
    console.log(`User changed: ${user?.uid}`);
});

</script>

<style lang="scss" scoped>
@use 'ihunter-pathfinder/styles' as Pathfinder;

.navigation-container {
  @include Pathfinder.PageContainer;
  background: var(--surface-fixed);
  user-select: none;

  .navigation-header {
    @include Pathfinder.PageContent;
    max-width: 680px;
    height: Pathfinder.$space-700;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: var(--surface-fixed);
    color: var(--on-surface-fixed);

    > div {
        display: flex;
        margin: 0 Pathfinder.$space-300;
    }

    .logo-stack {
      display: flex;
      align-items: center;
      color: #fff;
      font-size: 22px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1;
      letter-spacing: normal;
      gap: Pathfinder.$space-150;
      cursor: pointer;

      .wordmark {
        margin-right: -(Pathfinder.$space-50);
      }
    }

    @include Pathfinder.below(min) {
      .wordmark {
        display: none;
      }
    }
  }
}
</style>
